/*
 * Copyright (C) 2023. PLEO Interactive sp. z o.o. All rights reserved.
 * This code and its associated files are the proprietary property of PLEO Interactive  sp. z o.o and may not be copied, modified, or distributed without written permission.
 */

import { createSlice } from '@reduxjs/toolkit';

export const apiusSpaceSlice = createSlice({
	name: 'apiusSpace',
	initialState: {
		isOpen: false,
	},
	reducers: {
		setIsApiusSpaceOpen: (state, action) => {
			state.isOpen = action.payload;
		},
	},
});

export const { setIsApiusSpaceOpen } = apiusSpaceSlice.actions;

export default apiusSpaceSlice.reducer;
